import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-wrapper-horizontal',
  templateUrl: './formly-wrapper-horizontal.component.html',
  styleUrls: ['./formly-wrapper-horizontal.component.scss']
})
export class FormlyWrapperHorizontalComponent extends FieldWrapper
{
}
